import { Component, OnInit } from '@angular/core';
import *as moment from "moment";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { EnquiryService } from 'src/app/services/Enquiry/enquiry.service';

@Component({
  selector: 'app-issued-prospectus',
  templateUrl: './issued-prospectus.component.html',
  styleUrls: ['./issued-prospectus.component.css']
})
export class IssuedProspectusComponent implements OnInit {

  constructor(private enquiryService: EnquiryService, private lookupService: LookupService, public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }
  
  SearchModel = {
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    Print:""
}

EnquiryTypeList:any;
GetEnquiryType  () {
    this.lookupService.GetLookupsList('EnquiryType', '').subscribe( (data)=> {
        this.EnquiryTypeList = data.LookupItems;
    });
}

 ValidateDropdownSearch() {
    return this.SearchModel.FromDate == '' || this.SearchModel.ToDate == '';

};
Submitted = false;
FilePath:any;
XLSReport  () {
    
    this.Submitted = true;
    if (!this.ValidateDropdownSearch()) {

        
        this.SearchModel.Print = 'XLS';
       this.enquiryService.GetAllProspectus(JSON.stringify(this.SearchModel)).subscribe( (response)=> {
            if (response.webResponse.Status) {
                this.FilePath = response.FilePath;
                window.location = response.FilePath;

            }
            
        });
    }
}

PrintReport = function () {
    var divContents = document.getElementById("dvContainer").innerHTML;
    divContents = divContents.replace('no record found', '');
    var printWindow = window.open('', '', 'height=400,width=800');
    printWindow.document.write('<html><head><title>Voucher Receipt </title>');
    printWindow.document.write('<style type="text/css">');
    printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(divContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
}
ProspectusList:any;
GetAllProspectus  () {
    this.spinnerService.show();
    this.enquiryService.GetAllProspectus(JSON.stringify(this.SearchModel)).subscribe( (data) =>{
        this.ProspectusList = data.ProspectusDetails;
        this.spinnerService.hide()
    })
}


  ngOnInit() {
    this.GetEnquiryType();
    this.GetAllProspectus();
  }

}
